module.exports = __webpack_public_path__ + "static/media/Z10.0604fab2.jpg";